import { cn } from "lib/utils";
import { Card, CardContent } from "components/ui/card";
import { useTheme } from "hooks/use-theme";
import Chart from "react-apexcharts";
interface StatusBlockProps {
  className?: string;
  icon?: React.ReactNode;
  title?: string;
  timeline?: string;
  total?: number | string;
  series?: number[];
  chartColor?: string;
  iconWrapperClass?: string;
  chartType?: "area" | "bar" | "line" | "pie" | "donut" | "radialBar";
  reverse?: boolean;
  opacity?: number;
}

const StatusBlock = ({
  title,
  timeline,
  total,
  className,
  icon,
  series = [800, 600, 1000, 800, 600, 1000, 800, 900],
  chartColor = "#a8a854",
  iconWrapperClass,
  chartType = "area",
  reverse = false,
  opacity = 0.1,
}: StatusBlockProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { theme: mode } = useTheme();
  const chartSeries = [
    {
      data: series,
    },
  ];

  const options: any = {
    chart: {
      toolbar: {
        autoSelected: "pan",
        show: false,
      },
      offsetX: 0,
      offsetY: 0,
      zoom: {
        enabled: false,
      },
      sparkline: {
        enabled: true,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "60%",
        barHeight: "100%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    colors: [chartColor],

    tooltip: {
      // theme: mode === "dark" ? "dark" : "light",
      enabled: false,
    },

    grid: {
      show: false,
      padding: {
        left: 0,
        right: 0,
      },
    },
    yaxis: {
      show: false,
    },
    fill: {
      type: "solid",
      opacity: [opacity],
    },
    legend: {
      show: false,
    },
    xaxis: {
      low: 0,
      offsetX: 0,
      offsetY: 0,
      show: false,
      labels: {
        low: 0,
        offsetX: 0,
        show: false,
      },
      axisBorder: {
        low: 0,
        offsetX: 0,
        show: false,
      },
    },
  };
  return (
    <Card className={cn("", className)}>
      <CardContent className="p-5">
        <div
          className={cn("flex gap-3", {
            "flex-row-reverse": reverse,
          })}
        >
          {icon && (
            <div className="flex-none">
              <div
                className={cn(
                  "h-12 w-12 rounded-full flex flex-col items-center justify-center text-2xl bg-default/10",
                  iconWrapperClass,
                )}
              >
                {icon}
              </div>
            </div>
          )}

          {(title || total) && (
            <div className="flex-1">
              {title && (
                <div className="">
                  <p className="text-default-600 text-sm font-medium">
                    {title}
                  </p>
                  <p className="text-default-500 text-[11px] font-medium">
                    {timeline}
                  </p>
                </div>
              )}
              {total && (
                <div className="font-display text-default-900 text-xl font-semibold mt-1">
                  {total}
                </div>
              )}
            </div>
          )}
        </div>
        <div className="ms-auto max-w-[124px]">
          <Chart
            options={options}
            series={chartSeries}
            type={chartType}
            height={41}
            width={124}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export { StatusBlock };
